import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Util from '../Util';
import http from '../Api/http';
import { motion } from "framer-motion";
import { Briefcase, CheckCircle2 } from "lucide-react";

const Jobs = () => {
    const { t, i18n } = useTranslation();
    const language = i18n.language;
    const isRTL = language === "ar" || language === "he";
    const idImageRef = useRef();
    const licenseImageRef = useRef();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [failedMessage, setFailedMessage] = useState("");
    const [formData, setFormData] = useState({
        Id: 0,
        InsDate: new Date(),
        Name: '',
        Email: '',
        Phone: '',
        Notes: '',
        IdImage: null,
        LicenseImage: null,
        Smoker: "0"
    });
    const SmokerList = [
        { Id: 1, Name: t('yes') },
        { Id: 2, Name: t('no') },
    ]


    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: '' }));
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prev => ({ ...prev, [name]: files[0] }));
    };

    const validate = () => {
        console.log(formData.Smoker)
        let newErrors = {};
        if (!formData.Name || formData.Name.toString().trim() === "") newErrors.Name = t('requiredField');
        if (formData.Smoker === null || formData.Smoker === undefined || formData.Smoker.toString().trim() === ""
            || formData.Smoker.toString().trim() === "0") {
            newErrors.Smoker = t('requiredField');
        }
        if (!formData.Phone || formData.Phone.toString().trim() === "") newErrors.Phone = t('requiredField');
        if (!formData.Email || formData.Email.toString().trim() === "") newErrors.Email = t('requiredField');
        if (!formData.IdImage || formData.IdImage.toString().trim() === "") newErrors.IdImage = t('requiredField');
        if (!formData.LicenseImage || formData.LicenseImage.toString().trim() === "") newErrors.LicenseImage = t('requiredField');

        if (formData) {
            if (formData.Phone) {
                if (!Util.checkPhone(formData.Phone, false)) {
                    newErrors.Phone = t('phoneError')
                }
            } if (formData.Email) {
                if (!Util.checkEmail(formData.Email)) {
                    newErrors.Email = t('emailError')
                }
            }
        }

        return newErrors;
    };

    const onSave = async (e) => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        let files = [];
        files.push(formData.IdImage);
        files.push(formData.LicenseImage);
        console.log(formData)
        const obj = {
            Id: formData.Id,
            Name: formData.Name,
            Email: formData.Email,
            Phone: formData.Phone,
            Notes: formData.Notes,
            InsDate: new Date(),
            Smoker: formData.Smoker + '' === "1" ? true : false
        }
        try {
            setLoading(true);
            setSubmitted(true);
            const result = await http.postMultipartAxios(http.actions.Careers.Save, obj, null, files, t);
            if (result.status === 200 && result.data.success) {
                setErrors({});
                setFormData({
                    Id: 0,
                    InsDate: new Date(),
                    Name: '',
                    Email: '',
                    Phone: '',
                    Notes: '',
                    IdImage: undefined,
                    LicenseImage: undefined,
                    Smoker: "0"
                });
                if (idImageRef.current) idImageRef.current.value = '';
                if (licenseImageRef.current) licenseImageRef.current.value = '';
                setSuccessMessage(t('done'));
                setTimeout(() => setSuccessMessage(""), 3000); // إخفاء الرسالة بعد 3 ثواني
            } else {
                setFailedMessage(result.data.errorText || t('failed'));
                setTimeout(() => setFailedMessage(""), 3000);
            }
        }
        catch (e) {

        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen pt-10 pb-20 bg-background" dir={t('dir')}>

            {/* Hero */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-center mb-16"
            >
                <h1 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900 dark:text-white">
                    {t('joinOurTeam')}
                </h1>
                <div className="h-1.5 w-24 bg-accent mx-auto rounded-full" />
                <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                    {t('jobWelcome')}
                </p>
            </motion.div>

            {/* Content */}
            <section className="py-4 -mt-10">
                <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-6">

                    {/* Left Side */}
                    <div className="space-y-8">

                        <div className="bg-white p-8 rounded-2xl shadow-lg border">
                            <h2 className="text-2xl font-bold text-blue-600 mb-6 flex items-center gap-2">
                                <Briefcase className="w-6 h-6" />
                                {t('whyWorkWithUs')}
                            </h2>

                            <div className="space-y-4">
                                {[
                                    t('goodSalary'),
                                    t('goodEnvironment'),
                                    t('healthInsurance'),
                                    t('developmentChance'),
                                    t('annualVacations'),
                                    t('transportations')
                                ].map((item, idx) => (
                                    <div key={idx} className="flex items-center gap-3">
                                        <CheckCircle2 className="w-5 h-5 text-green-500" />
                                        <span className="text-gray-600">{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="bg-blue-50 p-8 rounded-2xl border">
                            <h3 className="text-xl font-bold text-blue-600 mb-4">
                                {t('currJobs')}
                            </h3>
                            <ul className="space-y-2 list-disc list-inside text-gray-600">
                                <li>{t('busDriver')}</li>
                                <li>{t('sedran')}</li>
                                <li>{t('mechanics')}</li>
                            </ul>
                        </div>

                    </div>

                    {/* Form */}
                    <div className="bg-white p-8 rounded-2xl shadow-xl border">
                        <h2 className="text-2xl font-bold text-blue-600 mb-1">
                            {t('jobForm')}
                        </h2>
                        {/* <p className="text-gray-500 mb-2">
                            {t('jobFormHint')}
                        </p> */}

                        <div className="space-y-1">
                            {/* Name */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="flex flex-col gap-1">
                                    <label>{t('name')}</label>
                                    <input
                                        name="Name"
                                        type="text"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        required
                                        className="w-full mb-1 bg-slate-50 rounded-lg border px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none resize-none"
                                    />
                                    {errors.Name && (<span className="text-red-500 text-sm">{errors.Name}</span>)}
                                </div>
                                <div className="flex flex-col gap-1">
                                    <label>{t('smoker')}</label>
                                    <select name="Smoker" value={formData.Smoker} onChange={handleChange}
                                        className="border px-2 rounded w-full border px-3 py-1 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" dir={t('dir')}>
                                        <option value="0">{t('select')}</option>
                                        {SmokerList.map(status => (
                                            <option key={status.Id} value={status.Id}>
                                                {status.Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.Smoker && (<span className="text-red-500 text-sm">{errors.Smoker}</span>)}
                                </div>
                            </div>

                            {/* Email + Phone */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                <div className="flex flex-col gap-1">
                                    <label>{t('email')}</label>
                                    <input
                                        name="Email"
                                        type="email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        required
                                        className="w-full mb-1 bg-slate-50 rounded-lg border px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none resize-none"
                                    />
                                    {errors.Email && (<p className="text-red-500 text-sm">{errors.Email}</p>)}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <label>{t('phone')}</label>
                                    <input
                                        name="Phone"
                                        type="text"
                                        value={formData.Phone}
                                        onChange={handleChange}
                                        required
                                        className="w-full mb-1 bg-slate-50 rounded-lg border px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none resize-none"
                                    />
                                    {errors.Phone && (<p className="text-red-500 text-sm">{errors.Phone}</p>)}
                                </div>

                            </div>


                            {/* Message */}
                            <div className="flex flex-col gap-1">
                                <label>{t('notes')}</label>
                                <textarea
                                    name="Notes"
                                    type="text"
                                    value={formData.Notes}
                                    onChange={handleChange}
                                    required
                                    className="w-full mb-1 bg-slate-50 rounded-lg border px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none resize-none"
                                />
                            </div>

                            {/* Attachments */}
                            <div className="flex flex-col md:flex-row gap-4">
                                {/* العنصر الأول */}
                                <div className="flex-1 flex flex-col gap-1">
                                    <label className="block text-gray-700 font-medium">{t('idImage')}</label>
                                    <input
                                        ref={idImageRef}
                                        id="idUpload"
                                        name="IdImage"
                                        type="file"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                        required
                                        className="hidden"
                                    />
                                    <label
                                        htmlFor="idUpload"
                                        className="cursor-pointer flex items-center justify-center w-full h-20 border-2 border-dashed border-blue-400 
                                        rounded-xl bg-blue-50 hover:bg-blue-100 transition text-blue-700"
                                    >
                                        📷 {t('idImageHint')}
                                    </label>
                                    {errors.IdImage && <p className="text-red-500 text-sm mt-1">{errors.IdImage}</p>}
                                </div>

                                {/* العنصر الثاني */}
                                <div className="flex-1 flex flex-col gap-1">
                                    <label className="block text-gray-700 font-medium">{t('licenseImage')}</label>
                                    <input
                                        ref={licenseImageRef}
                                        id="licenseUpload"
                                        name="LicenseImage"
                                        type="file"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                        required
                                        className="hidden"
                                    />
                                    <label
                                        htmlFor="licenseUpload"
                                        className="cursor-pointer flex items-center justify-center w-full h-20 border-2 border-dashed border-blue-400 
                                        rounded-xl bg-blue-50 hover:bg-blue-100 transition text-blue-700"
                                    >
                                        📷 {t('licenseImageHint')}
                                    </label>
                                    {errors.LicenseImage && <p className="text-red-500 text-sm mt-1">{errors.LicenseImage}</p>}
                                </div>
                            </div>

                            <button
                                type="button" onClick={() => { setSubmitted(true); onSave(); }}
                                className="w-full h-10 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg"
                            >
                                {t('saveReq')}
                            </button>
                            {successMessage && (
                                <div className="bg-green-100 text-green-800 p-2 rounded mb-2 text-center border border-green-400">
                                    {successMessage}
                                </div>
                            )}
                            {failedMessage && (
                                <div className="bg-red-100 text-red-800 p-2 rounded mb-2 text-center border border-red-400">
                                    {failedMessage}
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
};

export default Jobs;
